import * as React from "react";

import { ErrorBoundary, ErrorBoundaryPropsInterface, Suspense } from "..";

export const Boundary = React.memo<ErrorBoundaryPropsInterface>(
  function Boundary({ children, ...props }) {
    return (
      <ErrorBoundary {...props}>
        <Suspense>{children}</Suspense>
      </ErrorBoundary>
    );
  }
);
